var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 20,
    viewBox: "0 0 29 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8933 4.06545C16.5753 1.79076 18.4349 1.46169e-05 20.8129 1.46169e-05C25.3025 1.46169e-05 29 5.71483 29.0018 12.519C29.0018 16.6696 27.2147 19.2705 24.0048 19.2705C21.2081 19.2705 19.6638 17.7009 16.8925 13.0645L15.6836 11.0291L15.4697 10.672C15.1544 10.1392 14.8342 9.60931 14.5091 9.08245L12.3739 12.8525C9.34163 18.154 7.63425 19.2705 5.2635 19.2705C1.96838 19.2705 0 16.7058 0 12.6386C0 6.14076 3.61594 1.46169e-05 8.33388 1.46169e-05C8.91025 -0.00119372 9.4685 0.0725146 10.0086 0.22114C10.5705 0.377015 11.1161 0.61989 11.6634 0.958827C12.7093 1.60951 13.7551 2.61726 14.8933 4.06545ZM17.6411 8.09645C17.1843 7.35333 16.7451 6.66881 16.3234 6.04289L16.3125 6.02839C17.8441 3.66308 19.1092 2.48677 20.6118 2.48677C23.7347 2.48677 26.2341 7.08508 26.2341 12.7328C26.2341 14.8861 25.5273 16.1349 24.0682 16.1349C22.6671 16.1349 21.9983 15.2105 19.3376 10.933L17.6411 8.09645ZM8.78338 3.18277C10.0974 3.36402 11.2937 4.33189 13.0246 6.80958C12.0259 8.33891 11.038 9.87535 10.0612 11.4188C7.60163 15.2721 6.75156 16.1367 5.38313 16.1367C3.97481 16.1367 3.13563 14.9006 3.13563 12.693C3.13563 7.97683 5.48825 3.15195 8.294 3.15195C8.45954 3.15195 8.62267 3.16102 8.78338 3.18277Z",
    fill: "#0064E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.d1ac3089b4b47690a2736cb67fee1c9b.svg";
export { ForwardRef as ReactComponent };